/**
 * 音声認識 (ASR) 用のマイク制約 (PRODUCT_DEV-574 バッチ8)。
 *
 * 対話モードは AI の音声をスピーカーで鳴らすため、エコーキャンセルが無いとマイクが
 * AI の声を拾って VAD が誤発火し、文字起こしが濁る。自由モード (MediaRecorder) も
 * 同じ制約で揃える (Unizo の録音/対話と同じ 3 点)。
 *
 * DOM 型に依存するため shared-domain には置かない (Lambda バンドルへの混入防止)。
 */
export const ASR_AUDIO_CONSTRAINTS: MediaTrackConstraints = {
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};
